module.exports = __webpack_public_path__ + "static/W-d07375032db52e624c97f98b968deccc.jpg";